import React, { Fragment } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Recipient, RecipientRole } from 'features/document/constants';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, InputLabel, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import styles from './RecipientSelect.module.css';

interface RecipientSelectProps {
  recipientOptions: Recipient[];
  value?: Recipient | null;
  editRecipients?: boolean;
  onChange: (event: SelectChangeEvent) => void;
}

export default function RecipientSelect({
  recipientOptions,
  value,
  editRecipients = true,
  onChange,
}: RecipientSelectProps) {
  return (
    <Fragment>
      {!recipientOptions.length && !editRecipients ? (
        <Tooltip title={'Please add a recipient to enable the selection.'} arrow placement='top'>
          <FormControl
            fullWidth
            sx={{
              minWidth: '256px',
            }}
          >
            <InputLabel className='MuiInputLabel-disabled' id='recipient-select-label-id'>
              Recipients
            </InputLabel>
            <Select
              IconComponent={KeyboardArrowDownIcon}
              disabled
              id='recipient-select'
              labelId='recipient-select-label-id'
              label='Recipients'
              sx={{ height: '48px' }}
              value={value ? value.fullName : ''}
              onChange={onChange}
            >
              {recipientOptions.map(
                ({ fullName, color, id, role }) =>
                  role === RecipientRole.SIGNER && (
                    <MenuItem key={id} value={fullName} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Box display={'flex'}>
                        <div
                          className={styles.recipientCircle}
                          style={{
                            backgroundColor: color,
                          }}
                        />{' '}
                        {fullName}
                      </Box>
                      {id === value?.id && <CheckIcon sx={{ color: '#265183' }} />}
                    </MenuItem>
                  )
              )}
            </Select>
          </FormControl>
        </Tooltip>
      ) : (
        <FormControl
          fullWidth
          sx={{
            maxWidth: '256px',
          }}
        >
          <InputLabel id='recipient-select-label-id' sx={{ textAlign: 'center' }}>
            Recipients
          </InputLabel>
          <Select
            IconComponent={KeyboardArrowDownIcon}
            id='recipient-select'
            labelId='recipient-select-label-id'
            label='Recipients'
            sx={{ height: '48px' }}
            value={value ? value.fullName : ''}
            onChange={onChange}
          >
            {recipientOptions.map(
              ({ fullName, color, id, role }) =>
                role === RecipientRole.SIGNER && (
                  <MenuItem key={id} value={fullName} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box display={'flex'}>
                      <div
                        className={styles.recipientCircle}
                        style={{
                          backgroundColor: color,
                        }}
                      />{' '}
                      {fullName}
                    </Box>
                    {id === value?.id && <CheckIcon sx={{ color: '#265183' }} />}
                  </MenuItem>
                )
            )}
            {editRecipients && (
              <MenuItem value={'edit_recipients'}>
                <EditRoundedIcon color='primary' sx={{ marginRight: '8px' }} /> Edit Recipients
              </MenuItem>
            )}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
}
